import {Role} from '@/views/variables/roles'

const app = [
  {
    path: '/',
    component: () => import('@/views/layout/Main'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/houses/list',
        name: 'ApartmentAppList',
        title: 'Помещения',
        component: () => import('@/views/pages/apartment/List'),
        icon: 'occupant-list',
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        },
        display: true
      },
      {
        path: '/houses/list/:id',
        name: 'ApartmentItem',
        component: () => import('@/views/pages/apartment/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        }
      },
      {
        path: '/houses/list/:apartmentId/occupant/:id',
        name: 'ItemInfo',
        component: () => import('@/views/pages/apartment/ItemInfo'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        }
      },
      {
        path: '/occupant/list',
        name: 'OccupantAppList',
        title: 'Жильцы',
        component: () => import('@/views/pages/occupant/List'),
        icon: 'tenants-icon',
        iconRatio: 0.9,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        },
        display: true
      },
      {
        path: '/occupant/list/:id',
        name: 'OccupantItem',
        component: () => import('@/views/pages/occupant/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        }
      },
      {
        path: '/meeting/list',
        name: 'MeetingAppList',
        title: 'Собрания',
        component: () => import('@/views/pages/meeting/List'),
        icon: 'meeting-list',
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        },
        display: true
      },
      {
        path: '/meeting/list/:id',
        name: 'MeetingItem',
        component: () => import('@/views/pages/meeting/Item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        }
      },
      {
        path: '/application/list',
        name: 'ApplicationAppList',
        title: 'Заявки',
        component: () => import('@/views/pages/applications/index'),
        icon: 'applications-list',
        iconRatio: 1,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        },
        display: true
      },
      {
        path: '/application/list/:id',
        name: 'ApplicationListItem',
        component: () => import('@/views/pages/applications/item'),
        props: true,
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        }
      },
      {
        path: '/report/list',
        name: 'ReportAppList',
        title: 'Финансовые отчеты',
        component: () => import('@/views/pages/report/List'),
        icon: 'report',
        meta: {
          requiresAuth: true,
          authorize: [Role.Chairman]
        },
        display: true
      }
    ]
  }
]

export default app
